import Vue from 'vue'
import VueRouter from 'vue-router'
import categories from '@/assets/categories'

Vue.use(VueRouter)

const routes = categories.reduce((result, category) => {
  result = result.concat(category.items.map(item => ({
    path: item.path,
    component: () => import(`@/views/${category.name}/${item.componentName}`)
  })))
  return result
}, [])

const router = new VueRouter({
  routes,
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})

export default router
